var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { postWithAuthn } from "../RequestHelpers";
var SendTrackingNumberModal = /** @class */ (function (_super) {
    __extends(SendTrackingNumberModal, _super);
    function SendTrackingNumberModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                postWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId)
                    + ("/shipments/id/" + encodeURIComponent(_this.props.shipmentId) + "/email-tracking-number"))
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Could not send tracking number: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            errors: [],
            msg: ''
        };
        return _this;
    }
    SendTrackingNumberModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Email sent."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Email could not be sent."),
            React.createElement(FieldWithErrorDisplay, { errors: this.state.errors, errorPath: '/emailTracking', labelContent: '' },
                React.createElement(Button, { disabled: this.state.success, icon: 'mail', label: 'Send mail', labelPosition: 'left', onClick: this.submit, positive: true })));
    };
    return SendTrackingNumberModal;
}(React.PureComponent));
export default SendTrackingNumberModal;
//# sourceMappingURL=SendTrackingNumberModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SendTrackingNumberModal.js
// module id = 1264
// module chunks = 0